export default {"src":"/_next/static/media/close-grey.a784189d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};